import { Router, RouterLink } from '@angular/router';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AuthStatus, appstraxAuth } from '@appstrax/services/auth';

import { WorkspaceFacade } from '@state';
import { ToastService } from '@services';
import { mapAuthErrorMessage } from '../../../utils/auth-error.util';
import { navigateAfterAuthentication } from '../../../utils/auth-entry.util';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
  standalone: true,
  imports: [FormsModule, RouterLink],
})
export class LoginPage implements OnInit {
  private router = inject(Router);
  private workspace = inject(WorkspaceFacade);
  private toast = inject(ToastService);

  email: string = '';
  password: string = '';
  errorMessage: string = '';
  loading: boolean = false;

  async ngOnInit(): Promise<void> {
    if (await appstraxAuth.isAuthenticated()) {
      await navigateAfterAuthentication(this.router, this.workspace, this.toast);
    }
  }

  async onSubmit(): Promise<void> {
    if (!this.isFormValid()) {
      this.errorMessage = 'Please enter both email and password';
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    try {
      const response = await appstraxAuth.login({
        email: this.email,
        password: this.password,
      });

      if (response.status != AuthStatus.authenticated) {
        throw new Error(response.status);
      }

      await navigateAfterAuthentication(this.router, this.workspace, this.toast);
    } catch (error: any) {
      this.errorMessage = mapAuthErrorMessage(error);
    } finally {
      this.loading = false;
    }
  }

  public isFormValid() {
    return this.email != '' && this.password != '';
  }
}
